var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1 flex-column d-flex justify-center align-center"},[_c('p',{staticClass:"text-h6"},[_vm._v("The page you are looking for does not exist")]),_c('p',[_c('router-link',{attrs:{"to":"/appointments"}},[_vm._v("Go back to warehouse portal")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }